import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import { useGeneral } from '../../Context/GeneralContext';
import '../../styles/modalP.css';
import { Button } from '@material-ui/core';


import WarningNova from '../../img/warning.png';
import { LetterX } from 'tabler-icons-react';

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const useStyles = makeStyles((theme) => ({
    paper: {
        position: 'absolute',
        width: '660px',
        height: '630px',
        backgroundColor: '#118DFF',
        borderRadius: '10px',
        // border: '2px solid #000',
        boxShadow: theme.shadows[2],
    },
    root: {
        position: 'relative',
        width: '180px',
        height: '85px',
        marginTop: '20px',
        marginLeft: '20px',
        border: 'none',
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
}));

export default function ModalP() {
    const { openP, setOpenP, handleClickB, areas } = useGeneral();

    const classes = useStyles();
    // getModalStyle is not a pure function, we roll the style only on the first render
    const [modalStyle] = React.useState(getModalStyle);

    const handleClose = () => {
        setOpenP(false);
    };

    const body = (
        <div style={modalStyle} className={`${classes.paper} modal-appear-animated`}>
            {areas.length > 0 ? (
                <div className="modalP-body">
                    <div className="modalP-first">
                        <div className="modalP-warning">
                            <img src={WarningNova} className="modalP-warning-img" alt="Warning" />
                        </div>
                    </div>
                    <div className="modalP-second">
                        <LetterX
                            size={22}
                            color={'#ffffff'}
                            onClick={handleClose}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>
                    <div className="modalP-tittle">
                        <h1>Seleccione la categoría</h1>
                        <h1>del paro</h1>
                    </div>

                    <div className="modalP-body-div-first">
                        <Button
                            className="modalP-body-button"
                            style={{ backgroundColor: '#fe424d' }}
                            onClick={(e) =>
                                handleClickB(
                                    '#dd1717',
                                    'Rojo',
                                    '#FCCACD',
                                    areas[0].codigo,
                                    areas[0].nombre
                                )
                            }
                        >
                            <h1 style={{ color: '#ffffff' }}>{areas[0].nombre}</h1>
                        </Button>
                    </div>

                    <div className="modalP-body-div">
                        <Button
                            className="modalP-body-button"
                            style={{ backgroundColor: '#ffc800' }}
                            onClick={(e) =>
                                handleClickB(
                                    '#ffc800',
                                    'Amarillo',
                                    '#000',
                                    areas[1].codigo,
                                    areas[1].nombre
                                )
                            }
                        >
                            <h1 style={{ color: '#000' }}>{areas[1].nombre}</h1>
                        </Button>
                    </div>

                    <div className="modalP-body-div">
                        <Button
                            className="modalP-body-button"
                            style={{ backgroundColor: '#00A375' }}
                            onClick={(e) =>
                                handleClickB(
                                    '#00a375',
                                    'Verde',
                                    '#fff',
                                    areas[2].codigo,
                                    areas[2].nombre
                                )
                            }
                        >
                            <h1 style={{ color: '#ffffff ' }}>{areas[2].nombre}</h1>
                        </Button>
                    </div>

                    <div className="modalP-body-div">
                        <Button
                            className="modalP-body-button"
                            style={{ backgroundColor: '#0000ff' }}
                            onClick={(e) =>
                                handleClickB(
                                    '#0000FF',
                                    'Azul',
                                    '#fff',
                                    areas[3].codigo,
                                    areas[3].nombre
                                )
                            }
                        >
                            <h1 style={{ color: '#ffffff ' }}>{areas[3].nombre}</h1>
                        </Button>
                    </div>
                </div>
            ) : null}
        </div>
    );

    return (
        <div>
            <Modal
                open={openP}
                onClose={handleClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                {body}
            </Modal>
        </div>
    );
}
